import { useEffect, useState } from "react";
import { fetchLibrary } from "@/lib/api";
import CategoryRow from "@/components/CategoryRow";

export default function Browse() {
  const [items, setItems] = useState([]);
  useEffect(() => { fetchLibrary().then(setItems); }, []);
  const cats = Array.from(new Set(items.map(i => i.category)));

  return (
    <div className="pt-16" data-testid="browse-page">
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 py-10">
        <p className="text-[#D4AF37] text-[11px] font-semibold tracking-[0.25em] uppercase mb-2">Full Library</p>
        <h1 className="font-heading text-4xl md:text-6xl font-bold mb-10 leading-none">Browse VOTLiving</h1>
        <div className="space-y-12">
          {cats.map((c) => (
            <CategoryRow key={c} title={c} items={items.filter(i => i.category === c)} />
          ))}
        </div>
      </div>
    </div>
  );
}
